import { EventEmitter } from '@apia/util';
import {
  createContext,
  useContext,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { TToolbarIconButton } from './types';

type TClickListener = () => unknown;
type TItemState = Pick<
  TToolbarIconButton,
  'disabled' | 'toggled' | 'isLoading'
>;

export class ToolbarController extends EventEmitter<{
  pressEnter: string;
  updateItemState: string;
}> {
  eventListeners: Record<string, TClickListener[]> = {};
  itemsState: Record<string, TItemState> = {};

  hooks = {
    useItemState: (id: string, initialState: TItemState) => {
      const [state, setState] = useState(initialState);

      useEffect(() => {
        this.itemsState[id] = initialState;
        this.on('updateItemState', (evId) => {
          if (evId === id) {
            setState({ ...this.itemsState[id] });
          }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

      return state;
    },
  };

  setItemState = (id: string, newState: Partial<TItemState>) => {
    this.itemsState[id] = { ...this.itemsState[id], ...newState };
    this.emit('updateItemState', id);
  };

  Context = ({ children }: { children: ReactNode }) => {
    return (
      <ToolbarControllerContext.Provider value={this}>
        {children}
      </ToolbarControllerContext.Provider>
    );
  };
}

export const ToolbarControllerContext = createContext<ToolbarController | null>(
  null,
);

export const useToolbarControllerContext = () => {
  const context = useContext(ToolbarControllerContext);

  if (!context) throw new Error('There is no Toolbar controller context');

  return context;
};
